<nav 
  [class.nav-scrolled]="isScrolled"
  class="fixed top-0 left-0 right-0 z-50 transition-all duration-300 backdrop-blur-sm"
  [ngClass]="isScrolled ? 'bg-white shadow-lg' : 'bg-gradient-to-r from-white/95 to-white/90'"
>
  <div class="container-max flex items-center justify-between h-20 lg:h-24">
    <!-- Logo -->
    <a routerLink="/" class="flex items-center gap-2 shrink-0">
      <img 
        src="/images/velora-infra-logo.png" 
        alt="Velora Infra Logo"
        class="h-12 lg:h-14 w-auto"
      >
      <span class="hidden sm:block text-lg lg:text-xl font-bold text-primary-700">Velora Infra</span>
    </a>

    <!-- Desktop Menu -->
    <div class="hidden lg:flex items-center gap-12">
      <div class="flex gap-8">
        <a 
          *ngFor="let item of menuItems" 
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="text-slate-700 hover:text-primary-600 font-medium transition-colors duration-300 relative group"
        >
          {{ item.label }}
          <span class="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-primary-600 to-accent-500 group-hover:w-full transition-all duration-300"></span>
        </a>
      </div>

      <!-- CTA Button -->
      <a 
        routerLink="/contact"
        class="px-6 py-2.5 bg-gradient-to-r from-primary-600 to-accent-500 text-white font-semibold rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
      >
        Get Quote
      </a>
    </div>

    <!-- Mobile Menu Button -->
    <button 
      (click)="toggleMobileMenu()"
      class="lg:hidden p-2 rounded-lg transition-colors duration-300 hover:bg-slate-100 text-slate-900"
    >
      <svg 
        class="w-6 h-6 text-slate-900"
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          stroke-linecap="round" 
          stroke-linejoin="round" 
          stroke-width="2" 
          d="M4 6h16M4 12h16M4 18h16"
        ></path>
      </svg>
    </button>
  </div>

  <!-- Mobile Menu -->
  <div 
    *ngIf="isMobileMenuOpen"
    class="lg:hidden bg-white border-t border-slate-200 animate-fade-in-down"
  >
    <div class="container-max py-4 space-y-2">
      <a 
        *ngFor="let item of menuItems"
        [routerLink]="item.route"
        routerLinkActive="bg-primary-50"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="closeMobileMenu()"
        class="block px-4 py-2.5 text-slate-700 hover:text-primary-600 font-medium rounded-lg transition-colors duration-300"
      >
        {{ item.label }}
      </a>
      <a 
        routerLink="/contact"
        (click)="closeMobileMenu()"
        class="block px-4 py-2.5 bg-gradient-to-r from-primary-600 to-accent-500 text-white font-semibold rounded-lg text-center hover:shadow-lg transition-all duration-300"
      >
        Get Quote
      </a>
    </div>
  </div>
</nav>
